export enum NotificationViewState {
  Dismissed = 'Dismissed',
  Read = 'Read',
  Unread = 'Unread',
}
